<template>
  <div class="goods">
   <v-head :title="title"></v-head>
   <div class="means">
      <template>
        <img src="../../assets/images/user/default_tx.png" class="portrait" />
      </template>
      <div class="means_name">
       <p>您好，欢迎您的登录！</p>
       <p>用户名称：{{userInfo.name || '-'}}</p>
      </div>
     <!-- van-button round type="danger">成为会员</van-button> -->
   </div>
   <div class="member_means">
     <span>会员类型：{{getMemberType(userInfo.memberType) || '网员'}}</span>
     <span>有效期至： {{formatTime(userInfo.expiryDate) || '未成为正式会员'}}</span>
     <span>会员编号：{{userInfo&&userInfo.memberNo || '未生成会员号'}}</span>
   </div>
   <div class="icon_img">
	<van-row>
	  <van-col span="8">
	  	<div @click="seeMemberInfo()">
	  		<img src="../../assets/images/user/icon1.jpg">
	  		<h4>基本资料</h4>
	  	</div>
	  </van-col>
	  <van-col span="8" style="border-left: #dfdfdf solid 1px;border-right: #dfdfdf solid 1px;">
	  	<div @click="go('uploadAttachments')">
	  		<img src="../../assets/images/user/icon2.png">
	  		<h4>证件照片</h4>
	  	</div>
	  </van-col>
	  <van-col span="8">
	    <div @click="go('MembershipCard')">
	  		<img src="../../assets/images/user/football_name.png">
	  		<h4>电子会员证</h4>
	  	</div>
	  </van-col>
	</van-row>
	<van-row>
	  <van-col span="8">
	  	<div @click="go('PaymentList')">
	  		<img src="../../assets/images/user/liebiao.png">
	  		<h4>缴费列表</h4>
	  	</div>
	  </van-col>
	  <van-col span="8" style="border-left: #dfdfdf solid 1px;border-right: #dfdfdf solid 1px;">
	  	<div  @click="go('stationMessage')">
	  		<img src="../../assets/images/user/biangeng.png">
	  		<h4 style="padding-right: 15px;">站内信 <i v-show="iconNumber">{{unReadNum}}</i></h4>
	  	</div>
	  </van-col>
	  <van-col span="8" >
	  	<div  @click="go('ChangePassword')">
	  		<img src="../../assets/images/user/ai-bind-cel.png">
	  		<h4>修改密码</h4>
	  	</div>
	  </van-col>
	</van-row>
   </div>
  </div>
</template>

<script>
import {
    unRead,
	getUser
} from "@/api/dictionary";
import vHead from "../../components/header.vue";
import {Icon,Row, Col,Button, Dialog,} from 'vant';
import { getSessionStore, setSessionStore} from "../../utils/sessionStorage.js";
import { mapGetters, mapState,mapActions, mapMutations} from "vuex";

export default {
  data() {
    return {
    	title:"会员中心",
    	unReadNum:0,
    	iconNumber:true,
    };
  },
  components: {
  	vHead,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
	[Dialog.name]: Dialog,
  },

  methods: {
  	  ...mapActions(["getGroupMemberType", "getPersonMemberType"]),
	  ...mapMutations(["setMemberInfo"]),
	  go(pathName) {
		if(pathName == 'PaymentList'){
			 if(!this.userInfo.name || !this.userInfo.birthday || !this.userInfo.company || 
        !this.userInfo.idNumber || !this.userInfo.recommendUnitId || !this.userInfo.email){
		Dialog.confirm({
              title: "提示",
              message:
                "请先完善信息！",
            }).then(() => {
              this.$router.push({ name: "editMember" })
            })
            return
		}
		if(!this.userInfo.portraitId){
			Dialog.confirm({
              title: "提示",
              message:
                "请上传证件照！",
            }).then(() => {
              this.$router.push({ name: "uploadAttachments" })
            })
            return
		}
		}

		if(pathName == "MembershipCard"){		
			if(!this.userInfo.expiryDate){
				Dialog.alert({
				message: '正式会员可查看',
				}).then(() => {
				// on close
				});
				return;
			}
			if(this.userInfo.expiryDate){
				let expDate = new Date(this.userInfo.expiryDate)
          		let curDate = new Date()
				if(expDate <= curDate){
					Dialog.alert({
					message: '正式会员可查看',
					}).then(() => {
					// on close
					});
					return;
				}
			}
		}

	    this.$router.push({ name: pathName });
	  },
	  formatTime: function(dateUnix){
		  if(!dateUnix)return null;
		  let time = dateUnix.substring(0,10);
		  return time;
	  },
    seeMemberInfo: function(){
          this.$router.push({ name: 'editMember' });
      },
      unRead(){
          unRead({"memberId":this.memberId}).then(res =>{
              if (res.success) {
                this.unReadNum = res.result;
                if(this.unReadNum==0){
                	this.iconNumber = false;
                }
              }
          })
      },
  },
	computed:{
		...mapState(["userInfo"]),
		...mapGetters([ "getMemberType"])
	},
    mounted() {
		 getUser().then(res => {
          if (res.success) {
            this.setMemberInfo(res.result);
            window.sessionStorage.setItem("userInfo",JSON.stringify(res.result))
            setSessionStore("memberId", res.result.id);
          } else {
            Toast("用户信息获取失败, 请重新登录");
          }
        });

    	this.memberId = getSessionStore("memberId");
        this.getPersonMemberType();
        this.unRead();
    }
};
</script>

<style lang="less" scoped>

.means{ 
	padding:20px 13px 15px 13px; background:#378be1; overflow:hidden;
    .van-button{ float: right; background: #fff; color: #378be1; border:none; line-height: 26px; height: 30px;  margin-top:20px;
		}
}
.portrait{ width:15%; float:left;}
.means_name{float:left; font-size:14px; color:#fff; margin-top:3px;line-height:24px; margin-left:10px;}
.more{ float:right; margin-top:30px; color:#fff;}
.member_means{ background:#fff url(../../assets/images/user/bg_img2.jpg) no-repeat; background-size: 100%; 
	padding:20px 40px;  padding-right: 0;font-size:16px;
	color: #fff;overflow: hidden;;}
.member_means span{ float: left; display: block; margin-right:15px; line-height: 26px;font-size:14px;}
.icon_img{ background:#fff; padding: 20px 10px; font-size:14px; text-align: center; }
.icon_img img{ width: 50%; display:inline-block; margin-bottom: 10px;}
.van-row{ border-bottom: #dfdfdf solid 1px; }
.van-col{ padding: 20px 0;}
.van-col h4{ position: relative; }
.van-col i{text-align: center;color:#fff; font-weight: bold; background: red; font-size:10px; 
	display:block; position: absolute; right: 22%; width: 14px; height: 14px; border-radius: 50px; line-height: 14px;
	top:0px; }
</style>
